'use client'

import { useTranslation } from '@/hooks/client/use-translation'

import type { UpgradeComparison } from './upgrade-comparison'

import { NativeProductSelect } from '../native-product-select'

interface PriceUpgradeComparatorProps {
  modelName?: string
  comparisons: UpgradeComparison[]
  selectedComparison: UpgradeComparison
  onComparisonChange: (levelId: number) => void
}

export const PriceUpgradeComparator = ({
  modelName,
  comparisons,
  selectedComparison,
  onComparisonChange,
}: PriceUpgradeComparatorProps) => {
  const { t } = useTranslation()
  const comparisonName = modelName ? `${modelName} ${selectedComparison.levelName}` : selectedComparison.levelName

  return (
    <NativeProductSelect
      value={String(selectedComparison.levelId)}
      onValueChange={(value) => onComparisonChange(Number(value))}
      options={comparisons.map((comparison) => (
        <option key={comparison.levelId} value={String(comparison.levelId)}>
          {modelName ? `${modelName} ${comparison.levelName}` : comparison.levelName}
          {' · '}
          {comparison.isBase
            ? t('product.upgradeBaseLevel', 'Base technology level')
            : t('product.upgradeNextLevel', 'Next technology level down')}
        </option>
      ))}
      ariaLabel={t('product.upgradeChangeComparison', 'Change comparison from {{name}}', { name: comparisonName })}
      className="decoration-navy/40 hover:text-navy hover:decoration-navy focus-visible:outline-lapis cursor-pointer rounded-sm py-0.5 font-normal underline decoration-dotted underline-offset-2 focus-visible:outline-2 focus-visible:outline-offset-2"
    >
      {comparisonName}
    </NativeProductSelect>
  )
}
